import React, { useState, useEffect } from "react";
import { Dialog, Rating } from "@mui/material";
import axios from "axios";
import { EVENT_FEEDBACKS_URL } from '../ApiDetails';

const FeedbackComponent = ({ eventId }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      const response = await axios.get(`${EVENT_FEEDBACKS_URL}/${eventId}`);
      const filteredFeedBacks = response.data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

      setFeedbacks(filteredFeedBacks);
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
    }
  };

  const handleSubmitFeedback = async () => {
    try {
      await axios.post(
        EVENT_FEEDBACKS_URL,
        {
          id: 0,
          eventId: eventId,
          feedbackDescription: comment,
          feedbackRating: rating,
          createdDate: new Date().toISOString()
        }
      );
      setOpenPopup(false);
      setRating(0);
      setComment("");
      fetchFeedbacks();
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  return (
    <div className="container bg-light rounded p-3 mt-2 mb-1">
      <h4 className="pagetitle">Feedback</h4>
      <div className="row gx-2">
        {/* "Give a new Feedback" Button */}
        <div className="col-md-2 bg-light column m-0">
          <div
            className="feedback-card bg text-center"
            onClick={() => setOpenPopup(true)}
          >
            <svg
              width="20"
              height="22"
              viewBox="0 0 20 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 2.76953L5.8 2.76953C4.11984 2.76953 3.27976 2.76953 2.63803 3.09651C2.07354 3.38413 1.6146 3.84307 1.32698 4.40756C1 5.0493 1 5.88937 1 7.56953L1 12.7695C1 13.6995 1 14.1645 1.10222 14.546C1.37962 15.5813 2.18827 16.3899 3.22354 16.6673C3.60504 16.7695 4.07003 16.7695 5 16.7695V19.105C5 19.6379 5 19.9043 5.10923 20.0411C5.20422 20.1602 5.34827 20.2294 5.50054 20.2292C5.67563 20.229 5.88367 20.0626 6.29976 19.7297L8.68521 17.8214C9.17252 17.4315 9.41617 17.2366 9.68749 17.098C9.9282 16.975 10.1844 16.8851 10.4492 16.8308C10.7477 16.7695 11.0597 16.7695 11.6837 16.7695H13.2C14.8802 16.7695 15.7202 16.7695 16.362 16.4426C16.9265 16.1549 17.3854 15.696 17.673 15.1315C18 14.4898 18 13.6497 18 11.9695V11.7695M18.1213 2.64821C19.2929 3.81978 19.2929 5.71928 18.1213 6.89085C16.9497 8.06242 15.0503 8.06242 13.8787 6.89085C12.7071 5.71928 12.7071 3.81978 13.8787 2.64821C15.0503 1.47664 16.9497 1.47664 18.1213 2.64821Z"
                stroke="#0000A0"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <h4 className="mt-2">Give a new Feedback</h4>
          </div>
        </div>
        {/* Scrollable Feedback Cards */}
        <div className="col-md-10 bg m-0 p-0 ">
          <div className="row p-0 m-0">
            <div className="feedback-container scrollable-column">
              {feedbacks.map((feedback, index) => (
                <div key={index} className="col-md-4 scroll-content p-0 m-0 bg-light">
                  <div className="feedback-card text-center bg">
                    <svg
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_992_26907)">
                        <rect
                          x="0.5"
                          width="24"
                          height="24"
                          rx="12"
                          fill="#0000A0"
                        />
                        <rect
                          x="7.5"
                          y="4"
                          width="10"
                          height="10"
                          rx="5"
                          fill="#FFDC00"
                        />
                        <rect
                          x="-5.5"
                          y="16"
                          width="36"
                          height="36"
                          rx="18"
                          fill="#FFDC00"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_992_26907">
                          <rect
                            x="0.5"
                            width="24"
                            height="24"
                            rx="12"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <h4 className="mt-2">{feedback.feedbackUserName}</h4>
                    <p className="text-center p-0 m-0 mb-3">
                      {feedback.feedbackDescription}
                    </p>
                    <p className="text-center p-0 m-0">
                      <strong>
                        <span style={{ color: "#ffd32c", fontSize: "24px" }}>
                          {Array(feedback.feedbackRating)
                            .fill("★")
                            .map((star, index) => (
                              <span
                                key={index}
                                style={{
                                  color: "#ffd32c",
                                  fontSize: "24px",
                                }}
                              >
                                {star}
                              </span>
                            ))}
                        </span>
                        <span style={{ color: "lightgray", fontSize: "24px" }}>
                          {Array(5 - feedback.feedbackRating)
                            .fill("☆")
                            .map((star, index) => (
                              <span
                                key={index}
                                style={{
                                  color: "lightgray",
                                  fontSize: "24px",
                                }}
                              >
                                {star}
                              </span>
                            ))}
                        </span>
                      </strong>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Feedback Popup */}
        <Dialog
          open={openPopup}
          onClose={() => setOpenPopup(false)}
          maxWidth="xs"
          fullWidth
        >
          <div className="modal-content" style={{ color: "darkblue" }}>
            <h5 className="popupTitle">Give a feedback</h5>
            <p className="popup-text">
              What are your thoughts about this event?
            </p>

            <div className="form-group">
              <label htmlFor="comment" className="text-label">
                Comment
                <span className="text-danger">*</span>
              </label>
              <textarea
                id="comment"
                rows="3"
                placeholder="Enter your feedback here"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="form-control popup-textarea"
              />
            </div>

            <div className="mb-3">
              <label htmlFor="rating" className="text-label">
                Rating
                <span className="text-danger">*</span>
              </label>
              <div style={{ display: "flex", justifyContent: "left" }}>
                <Rating
                  name="feedback-rating"
                  value={rating}
                  onChange={(event, newValue) => {
                    if (comment) {
                      setRating(newValue);
                    } else {
                      alert("Please add a comment before giving a rating.");
                    }
                  }}
                  disabled={!comment}
                  precision={1}
                //sx={{ fontSize: "2rem", color: "#00BFFF" }}
                />
              </div>
            </div>

            <div
              className="modal-actions"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                className="btn btn-cancel"
                onClick={() => setOpenPopup(false)}
              >
                CANCEL
              </button>
              <button className="btn btn-save" onClick={handleSubmitFeedback}
                disabled={!comment || !rating}>
                SAVE
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default FeedbackComponent;